var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { SearchState } from './searchState';
import { Map, fromJS } from 'immutable';
import { searchActionType } from 'src/constants/searchActionType';
/**
 *  Image gallery reducer
 */
export var searchReducer = function (state, action) {
    if (state === void 0) { state = Map(new SearchState()); }
    var payload = action.payload;
    switch (action.type) {
        // case searchActionType.UPDATESEARCH:  
        // const post: Map<string, any> = payload
        // const updatePostOwnerId = post.get('ownerUserId')
        // const updatePostId = post.get('id')
        // return state
        // .set(['ResArr', updatePostOwnerId, updatePostId], Map(payload))
        // case searchActionType.ADD_LIST_POST:
        //     return state
        //       .mergeDeepIn(['ResArr'], payload)
        case searchActionType.ADD_POST:
            return state
                // .clear()
                // .deleteIn(['ResArr'])
                .set('ActiveSearch', true)
                .mergeIn(['ResArr', payload.uid, payload.post.id], fromJS(__assign({}, payload.post)));
        case searchActionType.ADD_FILTERM:
            return state
                // .clear()
                // .deleteIn(['ResArr'])
                // .set('ActiveSearch', true)
                .mergeIn(['Mens', payload.uid, payload.post.id], fromJS(__assign({}, payload.post)));
        case searchActionType.CLEAR:
            return Map({})
                .set('ActiveSearch', false);
        default:
            return state;
    }
};
//   import { User } from 'src/core/domain/users'
// import { Image } from 'src/core/domain/imageGallery'
// // - Import image gallery action types
// import { ImageGalleryActionType } from 'constants/imageGalleryActionType'
// import {rendererActionType} from 'constants/rendererActionType'
// import { IsearchAction } from './searchAction'
// import { SearchState } from './searchState'
// import { Map, fromJS } from 'immutable'
// import { checkoutActionType } from 'src/constants/checkoutActionType'
// import { searchActionType } from 'src/constants/searchActionType'
// /**
//  *  Image gallery reducer
//  */
// export let searchReducer = (state = Map(new SearchState()), action: IsearchAction) => {
//   const { payload } = action
//   switch (action.type) {
//     // case searchActionType.UPDATESEARCH:  
//     // const post: Map<string, any> = payload
//     // const updatePostOwnerId = post.get('ownerUserId')
//     // const updatePostId = post.get('id')
//     // return state
//     // .set(['ResArr', updatePostOwnerId, updatePostId], Map(payload))
//     // case searchActionType.ADD_LIST_POST:
//     //   const postArr1: any = payload
//     //   // alert(payload)
//     //   console.log('from state', postArr1.searchedPosts[0])
//     // if (postArr1.searchedPosts) {
//     //   postArr1.searchedPosts.forEach((element: any) => {
//     //     const pay = element
//     //     const post: Map<string, any> = Map({})
//     //     // const updatePostOwnerId = pay.get('ownerUserId')
//     //     post.set('', pay)
//     //     console.log('from state2', post)
//     //    return state
//     //     .setIn(['ResArr', element.ownerUserId, element.id], fromJS({...element}))
//     //   })
//     // }
//     //  return state
//     //  .setIn(['ResArr', postArr1.searchedPosts[0].ownerUserId, postArr1.searchedPosts[0].id], fromJS({...postArr1.searchedPosts[0]}))
//     case searchActionType.ADD_POST:
//         return state
//         // .clear()
//         // .deleteIn(['ResArr'])
//         .mergeIn(['ResArr', payload.uid, payload.post.id], fromJS({...payload.post}))
//     case searchActionType.CLEAR:
//         return Map({})
//     default:
//       return state
//   }
//   }



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/search/SearchReducer.ts
// module id = 588
// module chunks = 50